<script>
  export default {
    name: 'ResultMessage',
    props: {
      navigateBack: {
        type: Function,
        required: true
      },
      labels: {
        type: Object,
        required: true
      },
      title: {
        type: String,
        required: true
      },
      description: {
        type: String,
        required: true
      },
    },
  }
</script>


<template>
 <div class="nyk-pi-map__map-section__selected-bank">
        <button class="nyk-button nyk-button--link nyk-button--back" v-on:click="navigateBack">
            <div class="nyk-button__icon">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 12"><path fill="#07094A" d="M14 6.607V5.376H2.63l3.898-4.243L5.858.5 0 6.009 5.858 11.5l.67-.633-3.898-4.26H14Z"/></svg>
            </div>
            {{ labels.backButton }}
        </button>

        <div class="nyk-pi-map__map-section__selected-bank__header">
            <h3 class="nyk-pi-map__map-section__selected-bank__header__title">{{ title }}</h3>
            <div class="nyk-pi-map__map-section__selected-bank__content" v-html="description"></div>
        </div>

    </div>
</template>